import { render } from "./AdvertDisplay.vue?vue&type=template&id=6ab0838c&scoped=true"
import script from "./AdvertDisplay.vue?vue&type=script&lang=js"
export * from "./AdvertDisplay.vue?vue&type=script&lang=js"

import "./AdvertDisplay.vue?vue&type=style&index=0&id=6ab0838c&scoped=true&lang=css"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab0838c"]])

export default __exports__